import { appRoutes } from './appRoutes';

export const NON_SALESFORCE_ALLOWED_ROUTES: readonly string[] = [
  appRoutes.getStarted.route,
  appRoutes.agenticLayer.route,
  appRoutes.documentation.route,
  appRoutes.environments.route,
  appRoutes.settings.route,
];

/** Menu section IDs (not real routes) that non-Salesforce orgs can see; sub-items are filtered by NON_SALESFORCE_ALLOWED_ROUTES. */
export const NON_SALESFORCE_ALLOWED_MENU_IDS: readonly string[] = ['apps1'];

export const isNonSalesforceAllowedRoute = (pathname: string): boolean => {
  return NON_SALESFORCE_ALLOWED_ROUTES.some((route) => pathname.includes(route));
};
